import { render, staticRenderFns } from "./WorkspaceGraphViewportControls.vue?vue&type=template&id=fbcf7630&scoped=true"
import script from "./WorkspaceGraphViewportControls.vue?vue&type=script&lang=js"
export * from "./WorkspaceGraphViewportControls.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceGraphViewportControls.vue?vue&type=style&index=0&id=fbcf7630&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcf7630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbcf7630')) {
      api.createRecord('fbcf7630', component.options)
    } else {
      api.reload('fbcf7630', component.options)
    }
    module.hot.accept("./WorkspaceGraphViewportControls.vue?vue&type=template&id=fbcf7630&scoped=true", function () {
      api.rerender('fbcf7630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceGraphViewportControls.vue"
export default component.exports